import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  type: "constructor",
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }, {
    type: "string",
    name: "_symbol"
  }, {
    type: "uint8",
    name: "_decimals"
  }, {
    type: "uint256[4]",
    name: "_proportions"
  }, {
    type: "address",
    name: "_vestingBeneficiary"
  }, {
    type: "address",
    name: "_platformWallet"
  }, {
    type: "address",
    name: "_tokenVestingInstance"
  }, {
    type: "address",
    name: "_referral"
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Approval",
  inputs: [{
    type: "address",
    name: "owner",
    indexed: true
  }, {
    type: "address",
    name: "spender",
    indexed: true
  }, {
    type: "uint256",
    name: "value",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Transfer",
  inputs: [{
    type: "address",
    name: "from",
    indexed: true
  }, {
    type: "address",
    name: "to",
    indexed: true
  }, {
    type: "uint256",
    name: "value",
    indexed: false
  }]
}, {
  type: "function",
  name: "allowance",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "owner"
  }, {
    type: "address",
    name: "spender"
  }],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "approve",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "spender"
  }, {
    type: "uint256",
    name: "amount"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "balanceOf",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address",
    name: "account"
  }],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "decimals",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint8"
  }]
}, {
  type: "function",
  name: "decreaseAllowance",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "spender"
  }, {
    type: "uint256",
    name: "subtractedValue"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "increaseAllowance",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "spender"
  }, {
    type: "uint256",
    name: "addedValue"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "name",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "string"
  }]
}, {
  type: "function",
  name: "symbol",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "string"
  }]
}, {
  type: "function",
  name: "totalSupply",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "transfer",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "recipient"
  }, {
    type: "uint256",
    name: "amount"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "transferFrom",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "sender"
  }, {
    type: "address",
    name: "recipient"
  }, {
    type: "uint256",
    name: "amount"
  }],
  outputs: [{
    type: "bool"
  }]
}];
var SocialMoney__factory = /** @class */function () {
  function SocialMoney__factory() {}
  SocialMoney__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  SocialMoney__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  SocialMoney__factory.abi = _abi;
  return SocialMoney__factory;
}();

export { SocialMoney__factory };
